<template>
  <v-container>
    <div class="display-1 mb-3">Jobs</div>

    <v-simple-table height="500" dense fixed-header :loading="loading">
      <thead>
        <tr>
          <th class="text-left">Navn</th>
          <th class="text-left">Printet</th>
          <th class="text-left">Ejer</th>
          <th class="text-left">Blækforbrug</th>
          <th class="text-left">Papirforbrug</th>
          <th class="text-left">Papir</th>
          <th class="text-right">Totalt</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="job in jobs"
          :key="job.id"
          :class="{ 'grey--text cancelled grey lighten-5' : job.status == 'Cancel'}"
        >
          <td>
            <span v-if="job.name.length <12">{{ job.name}}</span>
            <v-tooltip bottom v-if="job.name.length>=12">
              <template v-slot:activator="{ on }">
                <span v-on="on">{{ job.name.substring(0,12)+".." }}</span>
              </template>
              <span>{{job.name}}</span>
            </v-tooltip>
          </td>
          <td>
            {{
            new Date(job.newPrinted.toDate()) | moment("Do MMM [kl. ] HH:MM") }}
          </td>
          <td>{{ job.owner }}</td>
          <td>{{ job.inkuse }}</td>
          <td>{{ job.paperuse }}</td>
          <td>
            <router-link to="/papers/">{{ job.paper }}</router-link>
          </td>
          <td class="text-right">{{ calculate(job.paperuse, job.inkuse, job.paper) }} kr</td>
        </tr>
      </tbody>
    </v-simple-table>

    <!--    <v-card
      class="pa-5 mb-2"
      :class="{ 'grey--text' : job.status == 'Cancel'}"
      flat
      v-for="job, index in jobs"
      :key="`job-${index}`"
    >{{ job.name.substring(0,10)+"..." }}- {{ new Date(job.newPrinted.toDate()) | moment("from")}} - Paper: {{job.paper}} - Paper: {{job.paperuse}} - Ink: {{job.inkuse}}- total cost: {{ calculate(job.paperuse, job.inkuse, job.paper) }} kr</v-card>-->
  </v-container>
</template>

<script>
//import Jobcard from './Jobcard';
//import { db } from '@/main';
//import store from '@/store';
export default {
  components: {
    // Jobcard
  },
  beforeCreate: function() {
    this.$store.dispatch('getSettings');
    this.$store.dispatch('getPapers');
    this.$store.dispatch('getJobs');
  },
  computed: {
    jobs() {
      return this.$store.getters.getJobs;
    },
    papers() {
      return this.$store.getters.getPapers;
    },
    settings() {
      return this.$store.getters.getSettings;
    }
  },
  methods: {
    calculate(paperuse, inkuse, papername) {
      let ink = inkuse.replace('ml', '');
      let result1 = ink * this.settings.costPrMl;
      let paper = paperuse.replace('m2', '');

      const paper2 = this.papers.find(paper => paper.name === papername);

      //console.log(paper, '+', paper2.m2cost); //papername, '-', paper2.name, paper2.cost);
      let result2 = paper * paper2.m2cost;
      const result = result1 * result2;

      if (result1 && result2) {
        return result.toFixed(2);
      } else {
        return 'NaN';
      }
    }
  },
  data: () => ({
    loading: true,
    whatsNext: [
      {
        text: 'Explore components',
        href: 'https://vuetifyjs.com/components/api-explorer'
      }
    ]
  })
};
</script>
<style>
.cancelled {
  text-decoration: line-through;
}
</style>
